export const ASIN_REGEX = '([Bb](?=.*\\d)[\\da-zA-Z]{9}|\\d{9}(X|\\d))'
